import { ComponentProps, FC } from 'react'
import { stencil } from 'react-common'
import { Header as UiKitHeader } from '@platform/ui'
import i18n from '@/plugins/i18n'
import styles from './UserMenuWide.module.scss'

const { UserMenuSlotPlugin } = stencil
type Locales = keyof typeof stencil.LOCALE_LABELS

const { UserContainer } = UiKitHeader
const { UserDefaultAvatar } = UserContainer
type MenuItem = ComponentProps<typeof UserDefaultAvatar>['items'][0]

type SelectEvent = {
  key: string
  keyPath: string[]
  selectedKeys: string[]
}

type UserMenuWideProps = {
  userName?: string
  menu: MenuItem[]
  currentLocale: Locales
  onSelect: (ev: SelectEvent) => void
}
export const UserMenuWide: FC<UserMenuWideProps> = (props) => {
  const { userName, menu, onSelect, currentLocale } = props
  const isRTL = i18n.dir() === 'rtl'

  return (
    <UserMenuSlotPlugin>
      <UserDefaultAvatar
        items={menu}
        onSelect={onSelect}
        userName={userName}
        selectedKeys={[currentLocale]}
        submenuClassName={styles.dropdown}
        separator={isRTL ? ' ' : ''} /* if is RTL we need to put space to user initials */
      />
    </UserMenuSlotPlugin>
  )
}
